<section [ngClass]="{'type-b': templateSuffix !== ''}">

  <h3 class="title" > Actualizar medios de contacto </h3>

  <p> Ajusta los medios de contacto para localizarle </p>

  <form [formGroup]="forma">

    <div class="options-container" formArrayName="metodos">
      <mat-checkbox *ngFor="let contact of contacts; let i = index" [formControlName]="i">
        {{ contact.description }}
      </mat-checkbox>
    </div>

  </form>


  <div class="container-buttons" *ngIf="!loading" >
    <button class="mt-2 btn-cancel" mat-button mat-dialog-close >
      Cancelar
    </button>
    <button class="mt-2 btn-danger-custom" (click)="save()" [disabled]="isThereNoChecks()" >
      Actualizar
    </button>
  </div>

  <ng-container *ngIf="loading">
    <div class="container-buttons" style="justify-content: center !important">
      <app-loading-spinner diameter="75px"></app-loading-spinner>
    </div>
  </ng-container>

</section>
